if not App.angularApp?
    return

App.angularApp.directive 'mfSlider', ['$parse', ($parse) ->
    return {
        restrict: 'A'
        scope:
            ngModel: '=ngModel'
        link: (scope, element, attrs) =>
            slideEventHandler = null

            sliderOpts = attrs.mfSlider
            opts = $parse(sliderOpts)(scope)
            element.slider(opts ? {})

            if attrs.mfSliderDisable?
                scope.$parent.$watch attrs.mfSliderDisable, (value) ->
                    if value
                        element.slider('disable')
                    else
                        element.slider('enable')

            element.on 'slide', (event, ui) ->
                scope.ngModel = ui.value
                scope.$apply()
                slideEventHandler?(event, ui)

            scope.$watch scope.ngModel, (value) ->
                return if value is undefined
                element.slider 'value', value

            element.slider 'value', scope.ngModel if scope.ngModel isnt undefined

            #element.on 'slide', attrs.mfSliderOnslide if attrs.mfSliderOnslide?
            scope.$parent.$watch attrs.mfSliderOnslide, (callback) ->
                slideEventHandler = callback

            scope.$on '$destroy', () ->
                element.slider('destroy')
    }
]
